type RuntimeEnv = {
  VITE_SUPABASE_URL?: string
  VITE_SUPABASE_ANON_KEY?: string
  VITE_DEV_AUTH?: string
  VITE_DEV_ADMIN_EMAIL?: string
  VITE_DEV_ADMIN_PASSWORD?: string
}

declare global {
  interface Window {
    __ENV__?: RuntimeEnv
  }
}

function fromWindow(key: keyof RuntimeEnv): string | undefined {
  const value = typeof window !== 'undefined' ? window.__ENV__?.[key] : undefined
  if (typeof value !== 'string') return undefined
  const trimmed = value.trim()
  if (!trimmed || trimmed.startsWith('${')) return undefined
  return trimmed
}

/**
 * Valores do build precisam de acesso estático (import.meta.env.CHAVE).
 * Acesso dinâmico import.meta.env[key] quebra no esbuild (env fica undefined).
 */
const BUILD_ENV: Record<keyof RuntimeEnv, string> = {
  VITE_SUPABASE_URL: String(import.meta.env.VITE_SUPABASE_URL ?? ''),
  VITE_SUPABASE_ANON_KEY: String(import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''),
  VITE_DEV_AUTH: String(import.meta.env.VITE_DEV_AUTH ?? 'false'),
  VITE_DEV_ADMIN_EMAIL: String(import.meta.env.VITE_DEV_ADMIN_EMAIL ?? ''),
  VITE_DEV_ADMIN_PASSWORD: String(import.meta.env.VITE_DEV_ADMIN_PASSWORD ?? ''),
}

/** Prefere env.js (runtime/Dokploy); cai para variáveis do build (Vite/esbuild). */
export function getRuntimeEnv(key: keyof RuntimeEnv): string {
  return fromWindow(key) || BUILD_ENV[key] || ''
}
